import clsx from "clsx";

import { ContactMapCard } from "@widgets/contact-map-card";

import { ShopCard } from "@features/shop-card";

import { Container } from "@shared/ui/container";
import { FilterPaginationContainer } from "@shared/ui/filter-pagination-container/filter-pagination-container";

import type { MerchType } from "@/_pages/merch/model";

import { getCurrentShopItem } from "../api/getCurrentItem";
import type { PageType, ShopListType } from "../model";
import { Hero } from "./hero";

import s from "./shop-page.module.scss";

export type ShopPageProps = {
  content: ShopListType;
  page: PageType;
};

export const ShopPage = (props: ShopPageProps) => {
  const { content, page } = props;

  return (
    <main className={clsx(s.root)}>
      {page?.hero?.length > 0 && <Hero data={page.hero} />}
      <FilterPaginationContainer
        initialContent={content}
        filters={[]}
        fetchFunction={getCurrentShopItem}
        renderCard={(item: MerchType) => (
          <ShopCard key={item.documentId} data={item} />
        )}
        showFilters={false}
        paginationThreshold={6}
        cardsClassName={s.cards}
      />
      {page?.contactMapSection && (
        <Container tag="section" className={s.mapContainer}>
          <ContactMapCard {...page?.contactMapSection} />
        </Container>
      )}
    </main>
  );
};

ShopPage.displayName = "ShopPage";
